export default function AuthCallback() {
  return <div>Auth Callback Page</div>;
}
